// extracted by mini-css-extract-plugin
module.exports = {"title":"LandscapeModal_title__oTUW-","text":"LandscapeModal_text__2L8OB","loading":"LandscapeModal_loading__f3Fs4","rotate":"LandscapeModal_rotate__1JyHA"};